<template>
    <div class="parent-wrapper">
        <div id="parent"
            :class="{ 'rotate-329' :  isAngleActive(329),'rotate-250' :  isAngleActive(250), 'rotate-179' :  isAngleActive(179), 'rotate-108' :  isAngleActive(108), 'rotate-37' :  isAngleActive(37) }" >
            <div class="main-component">
                <img src="https://assets.rhinorack.com/StowIt/stow-it-components/SSIT-03.jpg"
                    alt="Stow It Base Bracket">
                <span>Stow It Base<br> Bracket</span>
            </div>
                <!-- Roller Adaptor -->
            <div class="child child-37" @click="setParentAngle(37)">
                <!-- 179  -->
                <img src="https://assets.rhinorack.com/StowIt/stow-it-components/OSIT-00.jpg" alt="Roller Adaptor">
                <span>
                    Roller <br> Adaptor 
                </span>
            </div>
                <!-- Universal adaptor  -->
            <div class="child child-108" @click="setParentAngle(108)">
                <!-- 108 -->
                <img src="https://assets.rhinorack.com/StowIt/stow-it-components/SSIT-00.jpg" alt="Universal Adaptor">
                <span>Universal Adaptor</span>
            </div>
                <!-- Recovery Traction Board Holder -->
            <div class="child child-179 coming-soon" @click="setParentAngle(179)">
                <!-- 37 -->
                <img src="https://assets.rhinorack.com/Images/Accessories/RAFL/RAFL-01.jpg" alt="Recovery Traction Board Holder">
                <span>Recovery Traction <br> Board Holder</span>
            </div>
                <!-- Awning /Batwing adaptor -->
            <div class="child child-250 coming-soon" @click="setParentAngle(250)">
                <!-- 250 -->
                <img src=" https://assets.rhinorack.com/StowIt/stow-it-components/BSIT-00.jpg" alt="Batwing Adaptor">
                <span>Awning Adaptor</span>
                <!-- <span v-if="cultureValue != 'en-us'">Batwing Adaptor</span> -->
            </div>
                <!-- Light Bar -->
            <div class="child child-329" @click="setParentAngle(329)">
                <!-- 329 -->
                <img src="https://assets.rhinorack.com/StowIt/stow-it-components/ISIT-00.jpg" alt="Light Bar Adaptor">
                <span>Light Bar Adaptor</span>
            </div>
        </div>
                <!-- Roller Adaptor -->
        <div class="solutions" v-if="isAngleActive(37)">
            <a v-if="cultureValue == 'en-nz' || cultureValue == 'en-au' || cultureValue == 'en-us'" href="/product/LR1020" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('https://assets.rhinorack.com/Images/Accessories/LR615/LR615-00.jpg')">
                </div>
                <span class="solution-title">
                   1020mm <br>Ladder Roller
                </span>
            </a>
            <a v-if="cultureValue == 'en-nz' || cultureValue == 'en-au'" href="/product/LR880" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('https://assets.rhinorack.com/Images/Accessories/LR615/LR615-00.jpg')">
                </div>
                <span class="solution-title">
                   880mm <br>Ladder Roller
                </span>
            </a>
            <a  v-if="cultureValue != 'en-us'" href="/product/LR680" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('/product-image/LR680')">
                </div>
                <span class="solution-title">
                   680mm <br>Ladder Roller
                </span>
            </a>
            <a v-if="cultureValue != 'en-us'" href="/product/LR615" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('/product-image/LR615')">
                </div>
                <span class="solution-title">
                   615mm <br>Ladder Roller
                </span>
            </a>
            <a v-if="cultureValue != 'en-us'" href="/product/LR470" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('/product-image/LR470')">
                </div>
                <span class="solution-title">
                   470mm <br>Ladder Roller
                </span>
            </a>
        </div>
                <!-- Universal adaptor  -->
        <div class="solutions" v-if="isAngleActive(108)">
            <a href="/product/LSIT" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('https://assets.rhinorack.com/Images/Accessories/LSIT-Large-Stow-It-Utility-Holder/LSIT-Render-04-op.jpg')">
                </div>
                <span class="solution-title">
                   Utility Holder <br>(Large)
                </span>
            </a>
            <a href="/product/RSIT" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('/product-image/RSIT')">
                </div>
                <span class="solution-title">
                    Utility Holder <br>(Regular)
                </span>
            </a>
            <a href="/product/32132" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('/product-image/32132')">
                </div>
                <span class="solution-title">
                   Sunseeker 2.0 <br>Awning
                </span>
            </a>
            <a href="/product/32133" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('/product-image/32133')">
                </div>
                <span class="solution-title">
                   Sunseeker 2.5 <br>Awning
                </span>
            </a>

            <a v-if="cultureValue == 'en-au'" href="/product/BC2" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('https://assets.rhinorack.com/Images/Accessories/BC2-150/BC2-150-00.jpg')">
                </div>
                <span>
                    100mm Conduit <br>Clamp Set
                </span>
            </a>
            <a v-if="cultureValue == 'en-au'" href="/product/BC2-150" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('https://assets.rhinorack.com/Images/Accessories/BC2-150/BC2-150-00.jpg')">
                </div>
                <span>
                    150mm Conduit <br>Clamp Set
                </span>
            </a>

            <a v-if="cultureValue == 'en-us'" href="/product/32125" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('https://assets.rhinorack.com/Images/Accessories/32125/32125-Dome-1300-Awning-00.jpg')">
                </div>
                <span class="solution-title">
                    DOME 1300 <br>Awning
                </span>
            </a>
        </div>
                <!-- Recovery Traction Board Adaptor Holder -->
        <div class="solutions" v-if="isAngleActive(179)">

            <a href="/product/RAFL" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('https://assets.rhinorack.com/Images/Accessories/RAFL/RAFL-01.jpg ')">
                </div>
                <span class="solution-title">
                Aluminium <br>Folding Ladder
                </span>
            </a>
            <a href="/product/MSIT" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('https://assets.rhinorack.com/StowIt/stow-it-components/recovery-tracks.png')">
                </div>
                <span class="solution-title">
                Recovery Tracks <br> (Aftermarket)
                </span>
            </a>
        </div>
                <!-- Awning/Batwing adaptor -->
        <div class="solutions" v-if="isAngleActive(250)">
            <a v-if="cultureValue == 'en-us'" href="/product/32125" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('https://assets.rhinorack.com/Images/Accessories/32125/32125-Dome-1300-Awning-00.jpg')">
                </div>
                <span class="solution-title">
                    DOME 1300 <br>Awning
                </span>
            </a>
            <a href="/product/32133" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('/product-image/32133')">
                </div>
                <span class="solution-title">
                   Sunseeker 2.5 <br>Awning
                </span>
            </a>
            <a href="/product/32132" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('/product-image/32132')">
                </div>
                <span class="solution-title">
                   Sunseeker 2.0 <br>Awning
                </span>
            </a>
            <a href="/product/33116" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('/product-image/33116')">
                </div>
                <span>
                    Batwing Compact <br>Awning (Left)
                </span>
            </a>
            <a href="/product/33117" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('/product-image/33117')">
                </div>
                <span>
                    Batwing Compact <br>Awning (Right)
                </span>
            </a>
            <a href="/product/33114" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('https://assets.rhinorack.com/Images/Accessories/33114/33114-LH-Batwing-00.jpg')">
                </div>
                <span>
                    Batwing Awning <br>(Left)
                </span>
            </a>
            <a href="/product/33115" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('/product-image/33115')">
                </div>
                <span>
                    Batwing Awning <br>(Right)
                </span>
            </a>

            <a href="/product/LSIT" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('https://assets.rhinorack.com/Images/Accessories/LSIT-Large-Stow-It-Utility-Holder/LSIT-Render-04-op.jpg')">
                </div>
                <span class="solution-title">
                   Utility Holder <br>(Large)
                </span>
            </a>
            <a v-if="cultureValue == 'en-au'" href="/product/BC2" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('https://assets.rhinorack.com/Images/Accessories/BC2-150/BC2-150-00.jpg')">
                </div>
                <span>
                    100mm Conduit <br>Clamp Set
                </span>
            </a>
            <a v-if="cultureValue == 'en-au'" href="/product/BC2-150" target="_blank" class="solution-wrapper">
                <div class="solution" style="background-image: url('https://assets.rhinorack.com/Images/Accessories/BC2-150/BC2-150-00.jpg')">
                </div>
                <span>
                    150mm Conduit <br>Clamp Set
                </span>
            </a>
        </div>
                <!-- Light Bar -->
        <div class="solutions" v-if="isAngleActive(329)" style="cursor: not-allowed;">
            <div class="solution-wrapper">
                <div class="solution" style="background-image: url('https://assets.rhinorack.com/StowIt/stow-it-components/Base-Bracket-Lightbar-Adaptor.jpg')">
                </div>
                <span class="solution-title">
                    Light Bars <br>(Aftermarket)
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            
            return {
                parentAngle: 37,
                cultureValue: window.culture,
               
            }
        },
        methods: {
            setParentAngle(angle) {
                this.parentAngle = angle;
            },
            isAngleActive(angle) {
                if (angle == this.parentAngle) {
                    return true;
                }

                return false;
            }
        },
        computed: {
            getParentAngle() {
                return this.parentAngle;
            },
        }
    }

</script>

<style lang="scss" scoped>
    .parent-wrapper {
        display:flex;
        justify-content:center;
        align-items:center;
        overflow:hidden;
        flex-direction:column
    }
    #parent {
        width: 601px;
        height: 601px;
        border-radius: 51%;
        background: white;
        position: relative;
        margin-top: 4rem;
        transition-duration: 0.8s;
        transition-property: all;
        border: 80px solid rgb(228 239 246);
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;

        @media screen and (max-width: 768px) {
             width: 301px;
             height: 301px;
             border-width: 30px;
        }

        .main-component {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border: 4px solid #f4c44b;
            border-radius: 50%;
            overflow: hidden;
            text-align: center;
            font-family: 'trim-medium';
            color: #357fb7;
            font-size: 1.2rem;
            width: 250px;
            height: 250px;

            img {
                width: 100%;
            }

            @media screen and (max-width: 768px) {
             font-size: .7rem;
             width:120px;
             height:120px
            }

        }

        .overlay {
            display: none;
        }

        &.rotate-329 {
            transform: rotate(329deg);
            -webkit-transform: rotate(329deg);

            .main-component {
                transform: rotate(32deg);
            }

            .child.child-37 {
                transform: rotate(-22deg) translate(260px) rotate(55deg);
               border-color: lightgrey;
                @media screen and (max-width: 768px) {
                    transform: rotate(-22deg) translate(121px) rotate(55deg);
                }
                
            &:hover {
                border-color: #357fb7;
            }
            }

            .child.child-108 {
                transform: rotate(264deg) translate(260px) rotate(127deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(264deg) translate(121px) rotate(127deg);
                }
            }

            .child.child-179 {
                transform: rotate(193deg) translate(260px) rotate(198deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(193deg) translate(121px) rotate(198deg);
                }
            }
            .child.child-250 {
                transform: rotate(46deg) translate(260px) rotate(-15deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(46deg) translate(121px) rotate(-15deg);
                }
            }
            .child.child-329 {
                transform: rotate(121deg) translate(260px) rotate(272deg);
                border-color: #f4c44b;
                @media screen and (max-width: 768px) {
                    transform: rotate(121deg) translate(121px) rotate(272deg);
                }
            }


        }

        &.rotate-250 {
            transform: rotate(255deg);
            -webkit-transform: rotate(255deg);

            .main-component {
                transform: rotate(105deg);
            }

            .child.child-37 {
                transform: rotate(124deg) translate(260px) rotate(-19deg);
                border-color: lightgrey;
                @media screen and (max-width: 768px) {
                    transform: rotate(124deg) translate(121px) rotate(-19deg);
                }
                
            &:hover {
                border-color: #357fb7;
            }
            }

            .child.child-108 {
                transform: rotate(53deg) translate(260px) rotate(52deg);
                
                @media screen and (max-width: 768px) {
                    transform: rotate(53deg) translate(121px) rotate(52deg);
                }
            }

            .child.child-179 {
                transform: rotate(-23deg) translate(260px) rotate(129deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(-23deg) translate(121px) rotate(129deg);
                }
            }
            .child.child-250 {
                transform: rotate(196deg) translate(260px) rotate(269deg);
                border-color: #f4c44b;
                @media screen and (max-width: 768px) {
                    transform: rotate(196deg) translate(121px) rotate(269deg);
                }
            }
            .child.child-329 {
                transform: rotate(264deg) translate(260px) rotate(201deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(264deg) translate(121px) rotate(201deg);
                }
            }

        }

        &.rotate-179 {
            transform: rotate(179deg);
            -webkit-transform: rotate(179deg);

            .main-component {
                transform: rotate(181deg);
            }
            .child.child-37 {
                transform: rotate(49deg) translate(260px) rotate(131deg);
                border-color: lightgrey;
                @media screen and (max-width: 768px) {
                    transform: rotate(49deg) translate(121px) rotate(131deg);
                }
                
            &:hover {
                border-color: #357fb7;
            }
                
            }

            .child.child-108 {
                transform: rotate(-20deg) translate(260px) rotate(201deg);
                
                @media screen and (max-width: 768px) {
                    transform: rotate(-20deg) translate(121px) rotate(201deg);
                }
            }

            .child.child-179 {
                transform: rotate(268deg) translate(260px) rotate(275deg);
                border-color: #f4c44b;
                @media screen and (max-width: 768px) {
                    transform: rotate(268deg) translate(121px) rotate(275deg);
                }
            }
            .child.child-250 {
                transform: rotate(128deg) translate(260px) rotate(55deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(128deg) translate(121px) rotate(55deg);
                }
            }
            .child.child-329 {
                transform: rotate(196deg) translate(260px) rotate(-15deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(196deg) translate(121px) rotate(-15deg);
                }
            }

        }

        &.rotate-108 {
            transform: rotate(108deg);
            -webkit-transform: rotate(108deg);

            .main-component {
                transform: rotate(252deg);
            }

            .child.child-37 {
                transform: rotate(53deg) translate(251px) rotate(198deg);
                border-color: lightgrey;
                @media screen and (max-width: 768px) {
                    transform: rotate(49deg) translate(121px) rotate(198deg);
                }
                &:hover {
                border-color: #357fb7;
            }
            }

            .child.child-108 {
                transform: rotate(-22deg) translate(260px) rotate(275deg);
                border-color: #f4c44b;
                @media screen and (max-width: 768px) {
                    transform: rotate(-22deg) translate(121px) rotate(275deg);
                }
            }

            .child.child-179 {
                transform: rotate(268deg) translate(260px) rotate(-16deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(268deg) translate(121px) rotate(-16deg);
                }
            }
            .child.child-250 {
                transform: rotate(128deg) translate(260px) rotate(125deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(128deg) translate(121px) rotate(125deg);
                }
            }
            .child.child-329 {
                transform: rotate(198deg) translate(260px) rotate(55deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(198deg) translate(121px) rotate(55deg);
                }
            }

        }

        &.rotate-37 {
            transform: rotate(37deg);
            -webkit-transform: rotate(37deg);

            .main-component {
                transform: rotate(-37deg);
            }

            &.child-37 {
                transform: rotate(49deg) translate(260px) rotate(275deg);
                border-color: #f4c44b;
                @media screen and (max-width: 768px) {
                    transform: rotate(49deg) translate(121px) rotate(275deg);
                }
            }

            &.child-108 {
                transform: rotate(-22deg) translate(260px) rotate(-14deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(-22deg) translate(121px) rotate(-14deg);
                }
            }

            &.child-179 {
                transform: rotate(268deg) translate(260px) rotate(55deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(268deg) translate(121px) rotate(55deg);
                }

            }

            &.child-250 {
                transform: rotate(124deg) translate(260px) rotate(198deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(124deg) translate(121px) rotate(198deg);
                }
            }

            &.child-329 {
                transform: rotate(196deg) translate(260px) rotate(127deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(196deg) translate(121px) rotate(127deg);
                }
            }
        }

        .child {
            position: absolute;
            top: 51%;
            left: 51%;
            width: 160px;
            height: 160px;
            margin: -80px;
            background: white;
            border-radius: 51%;
            text-align: center;
            transform: all;
            border: 4px solid lightgrey;
            cursor: pointer;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            @media screen and (max-width: 768px) {
                width: 100px;
                height: 100px;
                margin: -52px;
            }

            &:hover {
                border-color: #357fb7;
            }
            img {
                width: 120px;//

            @media screen and (max-width: 768px) {
                line-height: 1.1;
                width: 80px;
            }

            }
            span {
                font-family: 'trim-medium';
                color: #357fb7;
                width: 80%;

                @media screen and (max-width: 768px) {
                    font-size: .7rem;
                }
            }
            &.child-37 {
                transform: rotate(49deg) translate(260px) rotate(275deg);
                border-color: #f4c44b;
                @media screen and (max-width: 768px) {
                    transform: rotate(49deg) translate(121px) rotate(275deg);
                }
            }

            &.child-108 {
                transform: rotate(-22deg) translate(260px) rotate(-14deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(-22deg) translate(121px) rotate(-14deg);
                }
            }

            &.child-179 {
                transform: rotate(268deg) translate(260px) rotate(55deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(268deg) translate(121px) rotate(55deg);
                }

            }

            &.child-250 {
                transform: rotate(124deg) translate(260px) rotate(198deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(124deg) translate(121px) rotate(198deg);
                }
            }

            &.child-329 {
                transform: rotate(196deg) translate(260px) rotate(127deg);
                @media screen and (max-width: 768px) {
                    transform: rotate(196deg) translate(121px) rotate(127deg);
                }
            }

            &.coming-soon {
                .overlay {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #8ca6d0bf;
                    span {
                        color: white;
                        text-transform: uppercase;
                    }
                }
            }
        }
    }

    .solutions {
        margin-top: 2rem;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding-bottom: 0;
        

        .solution-wrapper {
            text-decoration: none;
            text-align: center;
            cursor: pointer;
            color: #357fb7;
            font-family: 'trim-medium';
            padding-left: 1.2rem;

            .solution {
                width: 150px;
                height: 150px;
                border: 2px solid lightgrey;
                border-radius: 50%;
                margin: .2rem;
                display: flex;
                justify-content: center;
                align-items: center;
                font-family: 'trim-medium';
                text-align: center;
                color: #357fb7;

                @media screen and (max-width: 768px) {
                    width: 120px;
                    height: 120px;
                }

                &:hover {
                    border-color: #f4c44b;
                }

                background-position: center;
                background-size: contain;
                background-repeat: no-repeat; 
            }
            
            .overlay {
                span {
                    color: white;
                    text-transform: uppercase;
                }
                box-shadow: inset 0 0 0 1000px #8ca6d0bf; 
            }

            &:hover .solution-title {
                text-decoration: underline;
            }
    }


    }

</style>